export const ROOT_URL = "";
export const FETCH_KEYWORD_URL = "/api/user/pubmed";
export const FETCH_KEYWORD_WITH_FILTER_URL = "/api/yearfilter";
export const FETCH_KEYWORD_WITH_LIMIT_URL = "/api/total-limit";
export const FETCH_CLINICAL_TRIAL_URL = "/api/user/clinicaltrial";
export const SIGNUP_URL = "/api/signup";
export const LOGIN_URL = "/api/login";
export const PROFILE_URL = "/api/profile";
export const NON_USER_SEARCH_URL = "/api/non-user/keyword";
export const COLLABORATOR_CHART_URL = "/api/user/collaborator-chart";
export const USER_SEARCHES_URL = "/api/user/recent-searches";
export const SAVED_AUTHORS_URL = "/api/user/saved-authors";
export const POST_AUTHORS_URL = "/api/user/save-authors";
export const FETCH_EXPERT_URL = "/api/user/expert-search";
export const GET_AUTHOR_URL = "/api/user/get-expert";
export const AUTHOR_CITATION = "/api/author/citation";
export const CITATION_COUNT_PER_YEAR = "/api/author/citationcountperyear";
export const DELETE_USER_SEARCHES_URL = "/api/user/recently-searched/delete";
export const DELETE_SAVED_AUTHORS_URL = "/api/user/saved-authors/delete";
export const GET_ARTICLE_ABSTRACTION_URL = "/api/user/article";
export const GET_CLINICAL_TRIAL_INOF_URL = "/api/user/clinical-trial/article";
export const GET_AUTHOR_BIO_URL = "/api/author-bio-link";
export const ARTICLE_CITATION = "/api/article/citation";

/**
 * NEW URL END POINTS
 */
export const SEARCH_KEYWORD_URL = "/api/keyword/search";
export const SEARCH_KEYWORD_CLINICAL_TRIAL_URL =
  "/api/keyword/clinical-trial/search";
export const EXPERT_NAME_SEARCH_URL = "/api/keyword/author/search";
export const COLLABORATOR_URL = "/api/keyword/search/collaborators";
export const KEYWORD_COLLABORATION_URL =
  "/api/keyword/search/keyword-collaboration";
export const HOSPITAL_INFO_SEARCH_URL = "/api/hospital-info";
export const PROFILE_SEARCH_URL = "/api/author/profile";
export const PROFILE_COLLABORATOR_URL = "/api/profile/collaborators";
export const AFFILIATION_SEARCH_URL = "/api/search/affiliations";
export const AFFILIATION_EXPERT_SEARCH_URL = "/api/search/affiliation/experts";
export const USER_FETCH_URL = "/api/profile"; //wiil add the url once arun shares the api :)
export const USER_UPDATE_URL = "/api/profile/update";

export const trialSourceLinks = {
  "german clinical trials register":
    "https://www.drks.de/drks_web/navigate.do?navigationId=trial.HTML&TRIAL_ID=",
  "iranian registry of clinical trials":
    "https://www.irct.ir/search/result?query=",
  "australian new zealand clinical trials registry":
    "https://www.anzctr.org.au/Trial/Registration/TrialReview.aspx?id=",
  "clinicaltrials.gov": "https://clinicaltrials.gov/ct2/show/",
  "netherlands trial register": "https://www.trialregister.nl/trials?search=",
  "umin clinical trials registry（umin-ctr)":
    "https://upload.umin.ac.jp/cgi-open-bin/ctr_e/ctr_view.cgi?recptno=",
  "the peruvian clinical trials registry":
    "https://ensayosclinicos-repec.ins.gob.pe/en/about-repec/clinical-trial-search",
  "thai clinical trials registry (tctr)": "http://www.clinicaltrials.in.th/",
  "eu clinical trials register":
    "https://www.clinicaltrialsregister.eu/ctr-search/search?query=",
  isrctn: "https://www.isrctn.com/",
};

//NEW
export const REQUEST_EXPERTS = "/api/request/experts";

/**
 * GOOGLE ANALYTICS CONSTANTS
 */
export const GOOGLE_ANALYTICS = {
  SEARCHES: {
    ALL_RESULT: {
      category: "SEARCHES",
      action: "ALL_RESULT_SEARCH",
    },
    EXPERT_SEARCH: {
      category: "SEARCHES",
      action: "EXPERT_SEARCH",
    },
    CLINICAL_TRIAL_SEARCH: {
      category: "SEARCHES",
      action: "CLINICAL_TRIAL_SEARCH",
    },
    COLLABORATOR_NETWORK_SEARCH: {
      category: "SEARCHES",
      action: "COLLABORATOR_NETWORK_SEARCH",
    },
    TOPIC_SEARCH: {
      category: "SEARCHES",
      action: "TOPIC_SEARCH",
    },
    GEOGRAPHY_SEARCH: {
      category: "SEARCHES",
      action: "GEOGRAPHY_SEARCH",
    },
    UNREGISTER_USER_SEARCH: {
      category: "SEARCHES",
      action: "UNREGISTER_USER_SEARCH",
    },
  },

  CLICK: {
    SAVED_USER_VIEW_MORE_BTN: {
      category: "CLICK",
      action: "SAVED_USER_VIEW_MORE_BTN",
    },
    SAVED_AUTHOR_BIO_LINK: {
      category: "CLICK",
      action: "SAVED_AUTHOR_BIO_LINK",
    },
    SAVED_AUTHOR_SEARCH_KEYWORD_LINK: {
      category: "CLICK",
      action: "SAVED_AUTHOR_SEARCH_KEYWORD_LINK",
    },
    SAVED_AUTHOR_NEXT_BTN: {
      category: "CLICK",
      action: "SAVED_AUTHOR_NEXT_BTN",
    },
    SAVED_AUTHOR_PREVIOUS_BTN: {
      category: "CLICK",
      action: "SAVED_AUTHOR_PREVIOUS_BTN",
    },
    SAVED_AUTHOR_DELETE_BTN: {
      category: "CLICK",
      action: "SAVED_AUTHOR_DELETE_BTN",
    },
    RECENT_SEARCH_VIEW_MORE_BTN: {
      category: "CLICK",
      action: "RECENT_SEARCH_VIEW_MORE_BTN",
    },
    RECENT_SEARCH_LINK: {
      category: "CLICK",
      action: "RECENT_SEARCH_LINK",
    },
    RECENT_SEARCH_NEXT_BTN: {
      category: "CLICK",
      action: "RECENT_SEARCH_NEXT_BTN",
    },
    RECENT_SEARCH_PREVIOUS_BTN: {
      category: "CLICK",
      action: "RECENT_SEARCH_PREVIOUS_BTN",
    },
    RECENT_SEARCH_DELETE_BTN: {
      category: "CLICK",
      action: "RECENT_SEARCH_DELETE_BTN",
    },
    ALL_RESULT_SAVE_AUTHOR_BTN: {
      category: "CLICK",
      action: "ALL_RESULT_SAVE_AUTHOR_BTN",
    },
    EXPER_RESULT_SAVE_AUTHOR_BTN: {
      category: "CLICK",
      action: "EXPER_RESULT_SAVE_AUTHOR_BTN",
    },
    ALL_RESULT_SAVE_AUTHOR_SELECTED: {
      category: "CLICK",
      action: "ALL_RESULT_SAVE_AUTHOR_SELECTED",
    },
    ALL_RESULT_SAVE_AUTHOR_UN_SELECTED: {
      category: "CLICK",
      action: "ALL_RESULT_SAVE_AUTHOR_UN_SELECTED",
    },
    EXPERT_RESULT_SAVE_AUTHOR_SELECTED: {
      category: "CLICK",
      action: "EXPERT_RESULT_SAVE_AUTHOR_SELECTED",
    },
    EXPERT_RESULT_SAVE_AUTHOR_UN_SELECTED: {
      category: "CLICK",
      action: "EXPERT_RESULT_SAVE_AUTHOR_UN_SELECTED",
    },
    AUTHOR_BIO_PAGE_SAVE_AUTHOR_BTN: {
      category: "CLICK",
      action: "AUTHOR_BIO_PAGE_SAVE_AUTHOR_BTN",
    },
    AUTHOR_BIO_PAGE_ARTICLE_TITLE: {
      category: "CLICK",
      action: "AUTHOR_BIO_PAGE_ARTICLE_TITLE",
    },
    AUTHOR_BIO_PAGE_COAUTHOR_LINK: {
      category: "CLICK",
      action: "AUTHOR_BIO_PAGE_COAUTHOR_LINK",
    },
    AUTHOR_BIO_PAGE_TOPICS_LINK: {
      category: "CLICK",
      action: "AUTHOR_BIO_PAGE_TOPICS_LINK",
    },
    AUTHOR_BIO_PAGE_BIO_LINK: {
      category: "CLICK",
      action: "AUTHOR_BIO_PAGE_BIO_LINK",
    },
    AUTHOR_BIO_PAGE_CONTACT_LINK: {
      category: "CLICK",
      action: "AUTHOR_BIO_PAGE_CONTACT_LINK",
    },
  },

  HOVER: {
    AUTHOR_BIO_PAGE_CHART_HOVER: {
      category: "HOVER",
      action: "AUTHOR_BIO_PAGE_CHART_HOVER",
    },
  },
  AUTH: {
    REGISTER: {
      category: "AUTH",
      action: "INITIAL_REGISTER_BTN_CLICK",
    },
    REGISTER_RESEND_LINK: {
      category: "AUTH",
      action: "INITIAL_REGISTER_RESEND_BTN_CLICK",
    },
    CAPTCHA_FAILED: {
      category: "AUTH",
      action: "REGISTER_CAPTCHA_FAILED",
    },
    REGISTER_INFO: {
      category: "AUTH",
      action: "REGISTER_INFO_SEND",
    },
    REGISTERATION_SUCCESS: {
      category: "AUTH",
      action: "REGISTERATION_SUCCESS",
    },
    SIGNUP_PAGE_LOGIN_LINK_CLICK: {
      category: "AUTH",
      action: "SIGNUP_PAGE_LOGIN_LINK_CLICK",
    },
    FORGOT_PASSWORD_REQUEST: {
      category: "AUTH",
      action: "FORGOT_PASSWORD_REQUEST",
    },
    FORGOT_PASSWORD_REQUEST_RESEND_LINK: {
      category: "AUTH",
      action: "FORGOT_PASSWORD_REQUEST_RESEND_LINK",
    },
    NEW_PASSWORD_RESET_REQUEST: {
      category: "AUTH",
      action: "NEW_PASSWORD_RESET_REQUEST",
    },
    LOGIN_REQUEST: {
      category: "AUTH",
      action: "LOGIN_REQUEST",
    },
    LOGIN_FAILURE: {
      category: "AUTH",
      action: "LOGIN_FAILURE",
    },
    LOGIN_SUCCESS: {
      category: "AUTH",
      action: "LOGIN_SUCCESS",
    },
    LOGIN_PAGE_FORGOT_PASSWORD_CLICK: {
      category: "AUTH",
      action: "LOGIN_PAGE_FORGOT_PASSWORD_CLICK",
    },
    LOGIN_PAGE_NEW_USER_LINK_CLICK: {
      category: "AUTH",
      action: "LOGIN_PAGE_NEW_USER_LINK_CLICK",
    },
    OTHER_ERRORS: function (ERROR_MSG) {
      return {
        category: "AUTH",
        action: ERROR_MSG,
      };
    },
  },
};
